/**
 * SessionSection — phase, countdown, participant count, event-ended flag.
 */

import React from 'react';
import type { GmEventState } from '../../../../services/GmEventService';
import { Section, Row } from '../RaceDebugPrimitives';

const COLOR = '#3498db';

export const SessionSection: React.FC<{
  mapId: string;
  gmState: GmEventState;
}> = ({ mapId, gmState }) => (
  <Section title="Session" color={COLOR}>
    <Row label="map" value={mapId} />
    <Row label="phase" value={gmState.announcement?.phase ?? '—'} />
    <Row label="countdown"
         value={gmState.announcement
           ? `${gmState.announcement.secondsRemaining}s`
           : '—'} />
    <Row label="participants"
         value={gmState.announcement
           ? `${gmState.announcement.participantCount}/${gmState.announcement.maxParticipants}`
           : '—'} />
    <Row label="event ended" value={gmState.ended ? 'YES' : 'no'}
         valueColor={gmState.ended ? '#e74c3c' : undefined} />
  </Section>
);
